<div class="drawer-header">
   <h4>Client Contact Information</h4>
   <button
      class="v-button v-button-circle v-white v-graycolor"
      (click)="close()">
      <i class="icon fa fa-close"></i>
   </button>
</div>
<client-verification-rows [practiceSKey]="data.practiceSKey"></client-verification-rows>
